import { type VariantProps, cva } from "class-variance-authority";
import { Loader2 } from "lucide-react";
import type { HTMLAttributes } from "react";

import { cn } from "@/model/utils";

const spinerVariants = cva("flex items-center justify-center", {
  variants: {
    variant: {
      default: "flex items-center justify-center",
      load: "fixed top-0 left-0 z-100 w-full bg-black/50 flex items-center justify-center",
    },
    size: {
      default: "h-12 ",
      load: "min-h-screen",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
  },
});

type SpinnerProps = HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof spinerVariants> & {};

export const Spinner = ({ className, variant, size }: SpinnerProps) => (
  <div className={cn(spinerVariants({ variant, size, className }))}>
    <Loader2 className="text-text-primary h-8 w-8 animate-spin" />
  </div>
);
